import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BroadcastMessage, ClientMessage, ChatRoomMessage } from '@app/resolution-center/resolution-center.service';

@Component({
    selector: 'app-scheduled-messages-modal',
    templateUrl: './scheduled-messages-modal.component.html',
    styleUrls: ['./scheduled-messages-modal.component.scss'],
    standalone: false
})
export class ScheduledMessagesModalComponent {
    // Inputs provided via BsModalService initialState
    scheduledMessages: (ClientMessage | ChatRoomMessage | BroadcastMessage)[] = [];
    onEdit?: (message: ClientMessage | ChatRoomMessage | BroadcastMessage) => void;
    onReschedule?: (message: ClientMessage | ChatRoomMessage | BroadcastMessage) => void;
    onDelete?: (message: ClientMessage | ChatRoomMessage | BroadcastMessage) => Promise<void> | void;

    constructor(public bsModalRef: BsModalRef) {}

    close(): void {
        this.bsModalRef.hide();
    }

    handleEdit(message: ClientMessage | ChatRoomMessage | BroadcastMessage): void {
        if (this.onEdit) {
            this.onEdit(message);
        }
        this.close();
    }

    handleReschedule(message: ClientMessage | ChatRoomMessage | BroadcastMessage): void {
        if (this.onReschedule) {
            this.onReschedule(message);
        }
        this.close();
    }

    async handleDelete(message: ClientMessage | ChatRoomMessage | BroadcastMessage): Promise<void> {
        if (this.onDelete) {
            await this.onDelete(message);
        }
        // Close after delete so the inline panel and list stay in sync
        this.close();
    }
}

